import { render, staticRenderFns } from "./LeaveRequestsUser.vue?vue&type=template&id=4c81cd9c&scoped=true&"
import script from "./LeaveRequestsUser.vue?vue&type=script&lang=js&"
export * from "./LeaveRequestsUser.vue?vue&type=script&lang=js&"
import style0 from "./LeaveRequestsUser.vue?vue&type=style&index=0&id=4c81cd9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c81cd9c",
  null
  
)

export default component.exports